import { assertBoolean } from '../../validators';
import type {
    CommonAttributeSettings,
    PropDescriptor
} from './common';
import {
    createPropertyDescription,
    DEFAULT_ATTRIBUTE_SETTINGS
} from './common';


export const BOOLEAN_ATTRIBUTE_TYPE = 'booleanAttributeType';

/**
 * Creates an attribute decorator used to describe an boolean property. This will enforce a boolean
 * value of true or false.
 * @param settings
 */
export function BooleanAttribute(settings: Partial<CommonAttributeSettings> = {}) {
    settings = { ...DEFAULT_ATTRIBUTE_SETTINGS, ...settings };
    return function(target: object, propertyKey: string, descriptor: PropDescriptor) {
        return createPropertyDescription(target, propertyKey, descriptor, settings, assertBoolean, BOOLEAN_ATTRIBUTE_TYPE);
    } as any;
}
